'use client';

import type { Listing } from '@repo/api';
import { SectionContainer, SectionHeader } from '@/components/ui';
import { Description } from '@/components/shared/Description';

interface UnitDescriptionProps {
  listing: Listing;
}

export function UnitDescription({ listing }: UnitDescriptionProps) {
  const description = listing.description;

  if (!description) {
    return null;
  }

  return (
    <SectionContainer>
      <SectionHeader title="Description" className="w-full items-center md:items-start" />
      <div className="w-full px-2 md:px-4">
        <Description description={description} className="text-body-2 text-primary" />
      </div>
    </SectionContainer>
  );
}
